import type { CSSObject } from '@emotion/react';

import type {
  ThemeType,
} from '@n3/css-base';

export const createValueContainerStyle = ({
  colors,
  fonts,
  input,
}: ThemeType) => (): CSSObject => ({
  ...fonts.DEFAULT,
  alignItems: 'center',
  display: 'flex',
  flex: 1,
  flexWrap: 'wrap',
  WebkitOverflowScrolling: 'touch',
  position: 'relative',
  overflow: 'hidden',
  padding: '7px 15px',
  color: colors[input.TEXT_COLOR],
});
